"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThirdPartyPreQualificationSource = void 0;
/**
 * Defines the different sources of third party pre-qualification data.
 * @TranslateToPython @TranslateToEnum
 */
var ThirdPartyPreQualificationSource;
(function (ThirdPartyPreQualificationSource) {
    ThirdPartyPreQualificationSource["CreditKarma"] = "creditKarma";
})(ThirdPartyPreQualificationSource || (exports.ThirdPartyPreQualificationSource = ThirdPartyPreQualificationSource = {}));
